import CXMApiClient from "../../CXMApiClient";

const state = {
  ReportDiscrepancyModal: {
    ShowModal: false,
    ChosenTrim: null,
    EntityId: null
  },
};

const getters = {};

const actions = {
  openReportDiscrepancyModal(context, data) {
    context.commit("openReportDiscrepancyModal", data);
  },
  closeReportDiscrepancyModal(context) {
    context.commit("closeReportDiscrepancyModal");
  },
  reportDiscrepancy(context, requestPayload) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      let requestUrl = `/api/Dealsheet/entity/${requestPayload.entityId}/report_discrepancy`;
      cxmApiClient
        .ProcessRequest("POST", requestUrl, requestPayload)
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  }
};

const mutations = {
  openReportDiscrepancyModal(state, data) {
    state.ReportDiscrepancyModal.ShowModal = true;
    state.ReportDiscrepancyModal.ChosenTrim = data.chosenTrim;
    state.ReportDiscrepancyModal.EntityId = data.entityId;

  },
  closeReportDiscrepancyModal(state) {
    state.ReportDiscrepancyModal.ShowModal = false;
    state.ReportDiscrepancyModal.ChosenTrim = null;
    state.ReportDiscrepancyModal.EntityId = null;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/customerdashboard/ReportDiscrepancy.js